// import { Injectable } from '@angular/core';

// import { HttpClient } from '@angular/common/http';
// import { Observable } from 'rxjs';
// import { environment } from '../../../environments/environment';

// @Injectable({
//   providedIn: 'root'
// })
// export class SubCategoryService {

//   private apiUrl = `${environment.apiBaseUrl}/subCategories/getAllWithIds/{categoryId}`;

//   constructor(private http: HttpClient) { }

//   getSubcategoriesByCategory(categoryId: number): Observable<any[]> {
//     const apiUrl = `${environment.apiBaseUrl}/subCategories/getAllWithIds/${categoryId}`;
//     return this.http.get<any[]>(apiUrl);
//   }

// }


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubCategoryService {
  constructor(private http: HttpClient) {}

  getSubcategoriesByCategory(categoryId: number): Observable<any[]> {
    const url = `${environment.apiBaseUrl}/subCategories/getAllWithIds/${categoryId}`;
    return this.http.get<any[]>(url);
  }
}
